import { openAuthModal } from './header';
import { IMicrofrontendsAPI } from '../../../shared/types/microfrontends';

export * from './header';

export const microfrontendsAPI: IMicrofrontendsAPI = {
  header: { openAuthModal },
};
